// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ec0bd911","337":"d8d34b69","455":"c9c64f75"}[chunkId] + ".chunk.js";
};